import {ADD_DOWNLOAD, SET_DOWNLOAD_COUNT,SET_SHOW_DOWNLOAD,ADD_CANCEL_DOWNLOAD,REMOVE_DOWNLOAD, UPDATE_DOWNLOAD,REMOVE_CANCEL_DOWNLOAD,SHOW_CANCEL_POPUP,ADD_RETRY_DOWNLOAD,REMOVE_RETRY_DOWNLOAD,REFRESH_DOWNLOAD} from "../types/downloadBar";
import { DownloadState } from "../../types";

const initialState: DownloadState = {
  downloads: [],
  downloadCount: 0,
  showDownload: false,
  cancelledDownloads:[],
  cancelPopup:false,
  retryDownloads:[],
};

export const downloadBarReducer = (state = initialState, action: any): DownloadState => {
  switch (action.type) {
    case ADD_DOWNLOAD:
      return { ...state, downloads:[...state.downloads,action.payload] };
      
    case UPDATE_DOWNLOAD:
      return {...state,downloads:
          state.downloads.map((d) => {
            if (d.id === action.payload.id) {
              // const currentProgress = d.progress ?? 0;
              // const isInProgress = action.payload.statusList.includes("INPROGRESS");
              // const newProgress = isInProgress ?  Math.min(currentProgress + 5, 95):100;
              return {
                ...d,
                statusList: action.payload.statusList,
                totalRecordsCount: action.payload.records??0,
                // progress:(updatedRecordsCount!=undefined&&updatedRecordsCount>0)?newProgress:0,
              };
            }
            return d;
          })
        }

    case SET_DOWNLOAD_COUNT:
      return { ...state,
         downloadCount: state.downloadCount+action.payload };

    case SET_SHOW_DOWNLOAD:
      return { ...state, showDownload: action.payload };

    case ADD_CANCEL_DOWNLOAD:
        return {
          ...state,
          cancelledDownloads: [...state.cancelledDownloads, action.payload],
        };

    case REMOVE_DOWNLOAD:
      return {
        ...state,
        downloads: state.downloads.filter((d) => d.id !== action.payload),
      };

    case REMOVE_CANCEL_DOWNLOAD:
      return {
        ...state,
        cancelledDownloads: state.cancelledDownloads.filter(id => id !== action.payload)
      };

    case SHOW_CANCEL_POPUP:
      return{
        ...state,
        cancelPopup:action.payload,
      }

    case ADD_RETRY_DOWNLOAD:
      return{
        ...state,
        retryDownloads:[...state.retryDownloads,action.payload]
      }

    case REMOVE_RETRY_DOWNLOAD:
      return {
        ...state,
        retryDownloads: state.retryDownloads.filter(id => id !== action.payload)
      };
    case REFRESH_DOWNLOAD:{
      return {
        ...state,
        downloads:[],
      }
    }

    default:
      return state;
  }
};


